import { render } from "./PageManager.vue?vue&type=template&id=63d3de1c"
import script from "./PageManager.vue?vue&type=script&lang=js"
export * from "./PageManager.vue?vue&type=script&lang=js"

import "./PageManager.vue?vue&type=style&index=0&id=63d3de1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__